import { render, staticRenderFns } from "./HardwareBlockEditorHomeB.vue?vue&type=template&id=076ebc7e&scoped=true&"
import script from "./HardwareBlockEditorHomeB.vue?vue&type=script&lang=js&"
export * from "./HardwareBlockEditorHomeB.vue?vue&type=script&lang=js&"
import style0 from "./HardwareBlockEditorHomeB.vue?vue&type=style&index=0&id=076ebc7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ebc7e",
  null
  
)

export default component.exports